// extracted by mini-css-extract-plugin
module.exports = {"block":"filters_block___Bon7","filters":"filters_filters__k5Ebt"};